












































































/* component */
/* module */
import { Component, Prop, Watch, Vue } from 'vue-property-decorator'
import { harvestStatus, plantingSeason, routerPath } from '@/app/model/store/domain/const'
/* api */
import CommonClass from '@/app/module/common'

@Component({
  components: {}
})
export default class OrderTotal extends Vue {
  @Prop() private orderData!: any
  @Prop() private totalData!: any

  /* 見込反収 */
  private expectedHarvestAverage (sum: number) {
    if (sum === undefined || sum === null || this.totalData === 0) {
      return '-'
    } else {
      // 各作付けの見込反収の合計 ÷ 作付け数
      const data = Math.floor((sum / this.totalData) * 10) / 10
      return String(data).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')
    }
  }

  /* カンマ区切りにする */
  private toLocaleString (key: string, sum: number) {
    if (sum === undefined || sum === null || this.totalData === 0) {
      return '-'
    } else {
      const data = this.unitChange(key, sum)
      return String(data).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')
    }
  }

  private unitChange (key: string, val: number) {
    let number = 0
    if (key === 'ha') {
      return val
    } else {
      // kg → t または kg/10a → t/10a
      number = val / 1000
      return Math.floor(number * 10) / 10
    }
  }
}
